import React, { useState, useEffect } from 'react';

import {

  Box,

} from '@chakra-ui/react';

import QuestAnalytics from './QuestAnalytics';


import { getAllQuestAnalytics } from 'utils/activitycontrols/activities';

import Popup from 'components/alerts/Popup';
import OnToast from 'components/alerts/toast';

import { HashLoader } from 'react-spinners';
interface LearnerActivityData {
  sNo: number;
  lenUserName: string;
  lenMail: string;

  gameTitle: string;
  createdDate: any;
  cohortName: any;

 
}

interface RowObj {
  sNo: number;
  lenUserName: string;
  lenMail: string;
 
  gameTitle: string;
  createdDate: any;
  cohortName: any;
   quest1:any;
  quest2:any;
  quest3:any;
  quest4:any;
}



const CreatorCreation: React.FC = () => {
  const storage = JSON.parse(localStorage.getItem('user'));

  const UserRole = storage.data.role;
  const [apiData, setApiData] = useState<LearnerActivityData[]>([]);

  const [gameNames, setGames] = useState([]);
  const [cohorts, setcohort] = useState([]);

  const [companyNames, setCompany] = useState([]);
  const [alert, setAlert] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isConfirm, setIsConfirm] = useState(false);
  const [msg, setMsg] = useState<string>('');
  const [toastStatus, setToastStatus] = useState<string>('');
  const [deleteId, setDeleteId] = useState<number>(0);

  const [isToggled, setIsToggled] = useState(false);




  const [loadingdata, setLoadingdata] = useState(false);

  const transformData = (apiData: any) => {
    const dataArray = Array.isArray(apiData)
      ? apiData
      : apiData.rows || Object.values(apiData);

    if (!Array.isArray(dataArray)) {
      return [];
    }

      return dataArray.map((data, index) => {
    const questStatusMap: any = {};

    // Convert questWiseStatus array → object
    if (Array.isArray(data.questWiseStatus)) {
      data.questWiseStatus.forEach((q: any) => {
        questStatusMap[`quest${q.questNo}`] = q.status;
      });
    }

    return {
      ...data,
      sNo: data.sNo,
      lenUserName: data.lenUserName ?? '',
      lenMail: data.lenMail ?? '',
      gameTitle: data.gameTitle ?? '',
      createdDate: data.createdDate ?? '',
      cohortName: data.cohortName ?? '',
      // // 👇 Add dynamic quest columns
      quest1: questStatusMap.quest1 || 'Not Started',
      quest2: questStatusMap.quest2 || 'Not Started',
      quest3: questStatusMap.quest3 || 'Not Started',
      quest4: questStatusMap.quest4 || 'Not Started',
    };
  });
  
  };

  const transformedData: RowObj[] = transformData(apiData);

  return (
    <>
      <Box mb={{ base: '135px', md: '100px', xl: '100px' }}></Box>

      {loadingdata && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 9999,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backdropFilter: 'blur(10px)',
          }}
        >
          <HashLoader color="#3b38e0" />
        </div>
      )}
      <QuestAnalytics
        data={transformedData}
        setApiData={setApiData}
        setCompany={setCompany}
        setGames={setGames}
        setcohort={setcohort}
        apiData={apiData}
        isToggled={isToggled}
        setIsToggled={setIsToggled}
      />

      {isOpen ? (
        <Popup
          setDeleteId={setDeleteId}
          setIsConfirm={setIsConfirm}
          setIsOpen={setIsOpen}
          msg={''}
          setmsg={''}
        />
      ) : null}
      {alert ? (
        <OnToast msg={msg} status={toastStatus} setAlert={setAlert} />
      ) : null}
    </>
  );
};

export default CreatorCreation;
